import React, { useEffect, useState } from 'react';
import dashboardService from '../../features/dashboard/dashboardService';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import './pdf_dashboard.css';



function DashboardPdf() {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    console.log('queryParams', queryParams);
    // Retrieve specific query parameters  
    const districtId = queryParams.get('districtId');
    const authorization = queryParams.get('token');

    const [mangeDbData, setManageDbData] = useState(null)
    const [distNameDash, setDistNameDash] = useState('')
    let [isLoading, setIsLoading] = useState(false);
    let [isPageLoad, setisPageLoad] = useState(false);


    useEffect(() => {
        setIsLoading(true);
        // let districtId = localStorage.getItem('districtId')
        console.log('districtId:', districtId, 'authorization:', authorization);
        dashboardService.getDashboardPageDatePdf(districtId, authorization).then((response) => {

            // console.log(response.data);
            var sendArr = []
            var element = response.data.dashboardData

            for (let i = 0; i < response.data.dashboardData.length; i++) {
                if (element[i].accesslevel == "All") {
                    element[i].school = 'All Schools'
                    sendArr.push(element[i])
                    i = i + response.data.schoolList.length - 1
                } else {
                    sendArr.push(element[i])
                }
            }
            // console.log(sendArr);
            response.data['dbDataArr'] = sendArr
            // console.log(response.data);

            setManageDbData(response.data);
            setDistNameDash(response.data.distName)
            // console.log(response.data);
            // console.log(mangeDbData);
            setIsLoading(false)
            setisPageLoad(true)
        }).catch(err => {
            console.log("err", err);
        })
    }, []);

    const TableRowStyledManageDbPdf = styled(TableRow)`
         &:nth-of-type(odd) {
           background-color: #EEEEEE;
           border-right : 1px solid #FFFFFF;
         }
    `;

    return (

        <>
            <div className='pdfDash_pageHeader'>

                <div id="pdfImage">
                    <img alt="Delete School" src={require("../../assets/images/menuHeader.png")} className="pdfDash_logoSize"></img>
                </div>
                <div className="pdfDash_ImageSub">CalSCHLS Coordinator Portal</div>
                <div className="pdfDash_pgTitle">DASHBOARD USERS</div>
                <div className="pdfDash_country">{distNameDash ? distNameDash : ''}</div>

            </div>
            <div className='dash_pageContent_dash_pdf'>
                <div>
                    <TableContainer>
                        <Table >
                            <TableHead>
                                <TableRow className='headerStyle'>
                                    <TableCell style={{ width: '14%' }} className='schoolHeaderDashPdf'>NAME</TableCell>
                                    <TableCell style={{ width: '24%' }} className='schoolHeaderDashPdf'>EMAIL</TableCell>
                                    <TableCell style={{ width: '24%' }} className='schoolHeaderDashPdf'>SCHOOL</TableCell>
                                    <TableCell style={{ width: '12%' }} className='schoolHeaderDashPdf'>ACCESS LEVEL</TableCell>
                                    <TableCell style={{ width: '14%' }} className='schoolHeaderDashPdf'>SUBMITTED DATE</TableCell>
                                    <TableCell style={{ width: '12%' }} className='schoolHeaderDashPdf'>EXP. DATE</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>


                                {mangeDbData && mangeDbData.dbDataArr.map((element) => (

                                    <TableRowStyledManageDbPdf >

                                        <TableCell
                                            ref={el => {
                                                if (el) {
                                                    el.style.setProperty('padding', '4px 10px 10px 4px', 'important');
                                                }
                                            }}
                                            className='schoolBodyDashPdf'> {element.firstname}  {element.lastname}
                                        </TableCell>

                                        <TableCell ref={el => {

                                            if (el) {
                                                el.style.setProperty('padding', '4px 10px 10px 4px', 'important');
                                            }
                                        }} className='schoolBodyDashPdf'>{element.email}
                                        </TableCell>

                                        <TableCell ref={el => {

                                            if (el) {
                                                el.style.setProperty('padding', '4px 10px 10px 4px', 'important');
                                            }
                                        }} className='schoolBodyDashPdf'>
                                            {element.school != "All Schools" ?
                                                <>
                                                    {mangeDbData.schoolList.map(e => {
                                                        if (element.school == e.schoolId) {
                                                            return e.schoolName
                                                        }
                                                    })}
                                                </>

                                                : 'All Schools'}
                                        </TableCell>

                                        <TableCell ref={el => {

                                            if (el) {
                                                el.style.setProperty('padding', '4px 10px 10px 4px', 'important');
                                            }
                                        }} className='schoolBodyDashPdf'>{element.accesslevel.charAt(0).toUpperCase() + element.accesslevel.slice(1)}
                                        </TableCell>

                                        <TableCell ref={el => {

                                            if (el) {
                                                el.style.setProperty('padding', '4px 10px 10px 4px', 'important');
                                            }
                                        }} className='schoolBodyDashPdf'>{element.submitteddDate.split('T')[0]}
                                        </TableCell>

                                        <TableCell ref={el => {

                                            if (el) {
                                                el.style.setProperty('padding', '4px 10px 10px 4px', 'important');
                                            }
                                        }} className='schoolBodyDashPdf'>{element.expDate.split('T')[0]}
                                        </TableCell>

                                    </TableRowStyledManageDbPdf>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
            {isPageLoad ? <div id="pageload" ></div> : ''}

        </>
    )

}

export default DashboardPdf

